import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/queshaojilu.png'


const _withScopeId = n => (_pushScopeId("data-v-ec33c63a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lack" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-ec33c63a><div class=\"time\" data-v-ec33c63a>交易时间</div><div class=\"number\" data-v-ec33c63a>齿轮币/枚</div><div class=\"rmb\" data-v-ec33c63a>RMB/元</div><div class=\"type\" data-v-ec33c63a>交易类型</div><div class=\"mingxi\" data-v-ec33c63a>交易明细</div></div><img src=\"" + _imports_0 + "\" alt=\"\" data-v-ec33c63a><p data-v-ec33c63a>暂无交易记录</p>", 3)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    false
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "暂无消费记录"))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "暂无收益记录"))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "暂无充值记录"))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, "暂无提现记录"))
      : _createCommentVNode("", true)
  ]))
}